<script setup lang="ts">
    import { computed } from "vue"

    import { useUserStore } from "@/stores/user"
    import type { AssetData, CheckPermissionConfig } from "@/utils/checkPermissionConfig/index"
    import checkPermissionConfig from "@/utils/checkPermissionConfig/index"

    const props = withDefaults(
        defineProps<{
            requirePermission: string | string[]
            assetData?: AssetData | null
            config?: CheckPermissionConfig
        }>(),
        {
            assetData: null,
            config: () => ({}),
        }
    )

    const userStore = useUserStore()

    const hasPermission = computed(() =>
        checkPermissionConfig(props.requirePermission, userStore, props.assetData ?? null, props.config)
    )
</script>

<template>
    <div :style="{ display: hasPermission ? 'inline-block' : 'none' }">
        <slot :user-info="userStore.userInfo"></slot>
    </div>
</template>
